
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Paragraph, Anatomy } from '@ecl/website-components';

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Paragraph size="lead" mdxType="Paragraph">
  The dropdown/select, also known as a select menu, is a widget which displays a
  list of selectable items from which the user can select one value.
    </Paragraph>
    <h2>{`Anatomy`}</h2>
    <Anatomy image="https://inno-ecl.s3.amazonaws.com/media/images/EC/Select/Select2.jpg" alt="Anatomy of select" legend={{
      items: [{
        color: '#404040',
        label: 'Mandatory'
      }, {
        color: '#004494',
        label: 'Optional'
      }]
    }} mdxType="Anatomy" />
    <h3>{`Default`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Elements`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Mandatory`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Heading`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Heading describes the options in the Select Menu`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Helper text`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Helper text information assists a user in using Select Menu`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Dropdown List`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Dropdown in the collapsed state with placeholder giving instructions for using the Dropdown Select`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Action indicator`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Displays listed items on click`}</strong></td>
        </tr>
      </tbody>
    </table>
    <h3>{`Conditional (missing input)`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Elements`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Mandatory`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Optional indicator`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Indicator stating `}<strong parentName="td">{`if`}</strong>{` input fields are `}<strong parentName="td">{`optional`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Error message`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A message informing the user `}<strong parentName="td">{`if`}</strong>{` there is a problem with their entry`}</td>
        </tr>
      </tbody>
    </table>
    <h2>{`Do's`}</h2>
    <ul>
      <li parentName="ul">{`write short, distinct and indicative headings for the `}<strong parentName="li">{`items listed inside the dropdown`}</strong></li>
      <li parentName="ul"><strong parentName="li">{`use dropdown select menu labels as click targets (clicking the label will trigger the action)`}</strong></li>
      <li parentName="ul">{`indicate whether the input is `}<strong parentName="li">{`optional`}</strong></li>
      <li parentName="ul"><strong parentName="li">{`make use of helper text`}</strong>{` if there are further directions or hints the users may need in completing their goal (`}<strong parentName="li">{`example`}</strong>{`: `}<em parentName="li">{`you must be a current resident of this country`}</em>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`write specific and clear error message texts, so users understand how to address the error`}</strong></li>
    </ul>
    <h2>{`Don'ts`}</h2>
    <ul>
      <li parentName="ul"><strong parentName="li">{`don't use as navigation`}</strong></li>
      <li parentName="ul"><strong parentName="li">{`don't use it for multiple select`}</strong></li>
    </ul>
    <h2>{`When to use`}</h2>
    <ul>
      <li parentName="ul">{`when there are more than 10 options to select from`}</li>
    </ul>
    <h2>{`When not to use`}</h2>
    <ul>
      <li parentName="ul">{`when you want users to read all options`}</li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;